<mibi-box-layout>
    <nav class="mibi-footer-nav">
        <ul class="mibi-footer-nav-list">
            <li class="mibi-footer-nav-list__item">
                <a
                    class="mibi-footer-nav-link"
                    mat-button
                    color="primary"
                    href="https://www.bfr.bund.de"
                    target="_blank"
                >
                    BfR - Bundesinstitut für Risikobewertung
                </a>
            </li>
            <li class="mibi-footer-nav-list__item">
                <a
                    class="mibi-footer-nav-link"
                    mat-button
                    color="primary"
                    href="https://zoonotify.bfr.berlin/"
                    target="_blank"
                    >ZooNotify</a
                >
            </li>
            <li class="mibi-footer-nav-list__item">
                <a
                    class="mibi-footer-nav-link"
                    mat-button
                    color="primary"
                    [routerLink]="[mainLinks.faq]"
                    target="_blank"
                    >FAQ</a
                >
            </li>
            <li class="mibi-footer-nav-list__item">
                <a
                    class="mibi-footer-nav-link"
                    mat-button
                    color="primary"
                    [routerLink]="[contentLinks.dataProtection]"
                    target="_blank"
                    >Datenschutzerklärung</a
                >
            </li>
            <li class="mibi-footer-nav-list__item">
                <a
                    class="mibi-footer-nav-link"
                    mat-button
                    color="primary"
                    href="mailto:{{ supportMailConfig.recipient }}?subject={{
                        supportMailConfig.subject
                    }}:&body={{ supportMailConfig.body }}"
                    target="_top"
                >
                    Problem melden
                </a>
            </li>
        </ul>
    </nav>
</mibi-box-layout>
